<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="score-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title dialog-title"></h5>
                    <div class="score-view">
                        <vuescroll>
                            <div class="score-head"></div>
                            <div class="score-table">
                                <div class="data-view">
                                    <div class="data-item" v-for="(item,index) in score_data" :key="index" :class="{'odd' : index/2 == 0,'even' : index/2 > 0}">
                                        <div class="index table-cell">{{ (index + 1) }}</div>
                                        <div class="time table-cell">{{ item.record_time.substring(0, 16) || '----------- --:--:--' }}</div>  
                                        <div class="detail table-cell">
                                            <div class="score">{{ item.chge_score }}</div>
                                        </div>                                                                         
                                    </div>
                                </div>
                            </div>
                        </vuescroll>
                    </div>
                    <p class="notice">仅计入娱乐*三国无双/天命*荆州争霸/英霸官渡/英霸*天命无双/军团出征/军团出征*巅峰地图中获取的军威值</p>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.score-modal{
    width: 667px;
    height: 378px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
}

.notice{
    font-size: 20px;
    color: #bda487;
    text-align: center;
}

.title{
    width:463px;
    height:64px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/modal/title-score.png);  
}

.score-view{
    width: 608px;
    height: 210px;
    margin-left: 60px;
}

.score-head{
    width: 470px;
    height: 25px;
    margin-bottom: 20px;
    margin-left: 20px;
    background-image: url(~@/assets/images/modal/score-header.png);      
}

.data-item{
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    width: 515px;
    margin-bottom: 10px;
    padding: 8px 20px;
    font-size: 18px;
    color: #cbbda5;
    box-sizing: border-box;
    border: 1px solid #d18b64;
    /* border-radius: 40px; */
}

.table-cell{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 0;
    box-sizing: border-box;
    word-break: break-all;
    overflow: hidden;
}

.table-cell.time{
    margin-right: 113px;
}

.table-cell.index{
    width: 45px;
    margin-right: 50px;
}

.table-cell.detail{
    width: 100px;
}

</style>

<script>
import {
    apiQueryScore,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            text : '',
            score_data : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.render();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条 

            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        render (){
            apiQueryScore().then(
                res => {
                    this.score_data = res.data;
                },
                rej => {
                    this.$toast(rej.message)
                }                
            )
        },
        stopTouch(e){
            e.preventDefault();
        },                  
    },    
}
</script>